import React from 'react';
import { Eye, ArrowRight } from 'lucide-react';
import { TemplateCardProps } from '../../types/template';
import { Button } from '@/components/ui/button';
import { APP_CONFIG } from '@/config/app.config';

export const TemplateCard: React.FC<TemplateCardProps> = ({
  template,
  onClick,
  onPreview,
}) => {
  const thumbnailUrl = `https://template-${template.templateKey}.${APP_CONFIG.SITES_DOMAIN}/images/landing-site-preview-thumbnail.jpg`;
  return (
    <div className="group relative flex flex-col rounded-2xl overflow-hidden transition-transform duration-200 ease-expo-out hover:-translate-y-1">
      <button
        type="button"
        onClick={onClick}
        aria-label={`Select ${template.displayName}`}
        style={{
          backgroundImage: `url(${thumbnailUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
        }}
        className="aspect-video bg-foreground/5 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-foreground focus-visible:ring-offset-2"
      />

      <div className="relative flex items-center px-4 py-3 bg-foreground text-background">
        <h3 className="text-base font-medium text-background truncate flex-1 min-w-0">
          {template.displayName}
        </h3>

        <div
          className={[
            'absolute inset-y-0 right-3 flex items-center gap-2 pl-3 bg-foreground',
            'opacity-0 pointer-events-none transition-opacity duration-150',
            'group-hover:opacity-100 group-hover:pointer-events-auto',
            'group-focus-within:opacity-100 group-focus-within:pointer-events-auto',
          ].join(' ')}
        >
          {onPreview && (
            <Button
              type="button"
              variant="tertiary"
              size="icon"
              onClick={onPreview}
              title="Preview"
              aria-label={`Preview ${template.displayName}`}
              className="h-9 w-9 rounded-full bg-background/10 text-background hover:bg-background/20 active:bg-background/30"
            >
              <Eye className="h-4 w-4" />
            </Button>
          )}
          <Button
            type="button"
            variant="secondary"
            size="dense"
            onClick={onClick}
            className="hover:bg-surface active:bg-surface active:text-foreground"
          >
            Customize
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TemplateCard;
